import { tlISODateTimeToLocalString,tlResponseToUptimeString, tlISODateTimeToLocalNoSecondsString, Watch, MessageService, MessageFilter, ComponentService, BaseTLDetailComponent, AxiosResponse, RightHelper, ObjectTypesHelper, tlResponseDateToFormDateTimeString } from "../../../Infrastructure/CorBase/CoreBase";


	export default abstract class ComponentDetailBase extends BaseTLDetailComponent {
		componentService: ComponentService = new ComponentService();
		messageService: MessageService = new MessageService();
		returnRoute: string = "ComponentList";
		formData = {
			id: 0,
			idGroup: 0,
			idGroupText: '',
			componentId: '',
			name: '',
			description: '',
			isReceiverComponent: false,
			idComponentTypeNavigationName: '',
			idComponentStateNavigationName: '',
			portText: '',
			ipaddressText: '',
			ipaddressVPNText: '',
			macaddress: '',
			isActive: false,
			isDisabled: false,
			isWaitingForAcceptProvisioning: false,
			isLost: false,
			isProcessingTask: false,
			isDeleted: false,
			slot1: '',
			slot2: '',
			slot3: '',
			idComponentTypeNavigationIdentifier: '',
			//systemove udaje receiver

			//isReceiverComponent: false,
			//idComponentTypeNavigationName: '',
			//idComponentStateNavigationName: '',
			//portText: '',
			ipaddressLocalText: '',
			//ipaddressText: '',
			//ipaddressVPNText: '',
			//macaddress: '',
			//isActive: false,
			//isDisabled: false,
			//isWaitingForAcceptProvisioning: false,
			//isLost: false,
			//isProcessingTask: false,
			//isDeleted: false,

			idComponent: 0,
			idVariant: 0,
			idVariantText: '',
			idDisplayOrientation: 0,
			idDisplayOrientationText: '',
			enableDisplayTurnOff: null,
			sendPrintScreen: null,
			audioEnabled: null,
			idAudioOutput: 0,
			idContentInBootUpScreen: 0,
			idContentInBootUpScreenText: '',
			idGroupNavigationName: '',
			backgroundColor: '' as string,
			taskActual: null,
			taskCommon: null,
			taskPriority: null,
			taskIdle: null,
			tags: null,
			idAudioOutputText: '',
			operatingSystem: '',
			dotnet: '',
			programVersion: '',
			displayResolution: '',
			storage: '',
			storageData: '',
			cPU: '',
			cPUTemperature: '',
			rAM: '',
			hardwarePlatform: '',
			videoOutput: '',
			audioOutput: '',
			useCPU: '',
			uptime: '',
			localTime: '',
			contentInBootUpScreen: null,
			dateOfConfiguration: '',
			error: '',
			progressList: null,
		}

		isTranscoder = false;

		variantList: any[] = [];
		contentImageList: any[] = [];
		showParamsDetail = true;

		createdBase() {
			this.showParamsDetail = this.$store.state.showDetailParamFirstShow;	
		}
		historyMessageAll: [] = [];
		showHistoryMessageModal() {
			this.initMessageHistory();
			this.$bvModal.show('historyMessageModal');
		}

		cancelComponentMessage(item: any) {
			this.messageService.cancelMessage(Number(item.id), null).then(res => {
				(this.historyMessageAll.filter((c: any) => c.id == item.id)[0] as any).allowDelete = false;
				(this.historyMessageAll.filter((c: any) => c.id == item.id)[0] as any).isCanceledText = "Ano";
			}
			);
		}

		protected initMessageHistory(): void {
			this.isBusy = true;
			let messageFilter: MessageFilter = new MessageFilter(this.formData.id);
			this.messageService.getAllByFilter(messageFilter).then(response => {
				this.historyMessageAll = response.data;
				this.prepareItemsForModal(this.historyMessageAll);
				this.isBusy = false;
			});
		}

		protected prepareItemsForModal(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].creationDateFrom = items[i].creationDate;
				items[i].creationDateTo = items[i].creationDate;
				items[i].receiveDateFrom = items[i].receiveDate;
				items[i].receiveDateTo = items[i].receiveDate;
			}
		}

		fieldsMessageHistoryModal = [
			{ key: 'idMessageTypeText', label: this.$t('component.messageFieldType'), trans: 'component.messageFieldType', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'creationDate', label: this.$t('component.messageFieldCreated'), trans: 'component.messageFieldCreated', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
			{ key: 'receiveDate', label: this.$t('component.messageFieldAccepted'), trans: 'component.messageFieldAccepted', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
			{ key: 'sendAttemptCountText', label: this.$t('component.messageFieldCount'), trans: 'component.messageFieldCount', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'isCanceledText', label: this.$t('component.messageFieldCountCanceled'), trans: 'component.messageFieldCountCanceled', sortable: true, sortDirection: 'asc', class: 'text-center' },


			{ key: 'sendDate', label: this.$t('component.messageFieldSend'), trans: 'component.messageFieldSend', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), optional: true, visible: false },
			{ key: 'nextSendDate', label: this.$t('component.messageFieldNextSendDate'), trans: 'component.messageFieldNextSendDate', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), optional: true, visible: false },
			{ key: 'body', label: this.$t('component.messageFieldBody'), trans: 'component.messageFieldBody', sortable: false, sortDirection: 'asc', class: 'text-center', optional: true, visible: false },

			{ key: 'actions', label: this.$t('component.messageFieldAction'), sortable: false, class: 'text-right' },
		];

		itemsAnswer = [
			{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
			{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }];

		filtersMessageHistoryModal = [
			
		
			{ key: 'creationDateFrom', label: this.$t('component.messageFieldCreatedFrom'), trans: 'component.messageFieldCreatedFrom', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'creationDate' },
			{ key: 'creationDateTo', label: this.$t('component.messageFieldCreatedFrom'), trans: 'component.messageFieldCreatedFrom', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'creationDate' },
			{ key: 'receiveDateFrom', label: this.$t('component.messageFieldAcceptedFrom'), trans: 'component.messageFieldAcceptedFrom', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'receiveDate' },
			{ key: 'receiveDateTo', label: this.$t('component.messageFieldAcceptedTo'), trans: 'component.messageFieldAcceptedTo', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'receiveDate' },
			{ key: 'isCanceledText', label: this.$t('component.messageFieldCountCanceled'), trans: 'component.messageFieldCountCanceled', selected: false, value: null, type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsAnswer },
		];

		prepareFilters() {
			var taskStateEnums = { key: 'ENU_COR_Message_Type', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idMessageTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('component.messageFieldType'), trans: 'component.messageFieldType', isNegative: true };
			this.loadFiltersEnumListModal([taskStateEnums], this.filtersMessageHistoryModal);
			return this.filtersMessageHistoryModal;
		}

	


		public showSystemInfoReceiver() {			
			var result = this.formData.idComponentTypeNavigationIdentifier == 'ENU_COR_Component_Type_Receiver';
			this.isTranscoder = this.showSystemInfo() && !result;
			return result;
        }

		public showSystemInfo() {			
			return this.formData.idComponentTypeNavigationIdentifier == 'ENU_COR_Component_Type_Receiver'
				|| this.formData.idComponentTypeNavigationIdentifier == 'ENU_COR_Component_Type_TranscoderWorker';
        }

		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInputBase(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.componentService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.componentService.getRefreshById(this.objectId);
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.idGroup = response.data.idGroup;
			this.formData.idGroupText = response.data.idGroupText;
			this.formData.componentId = response.data.componentId;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;
			//VaP - v detailu komponenty nebude zobrazovat informace o receiveru, na to slouzi receiverdetail
			this.formData.isReceiverComponent = false;
			this.formData.idComponentTypeNavigationName = response.data.idComponentTypeNavigationName;
			this.formData.idComponentStateNavigationName = response.data.idComponentStateNavigationName;
			this.formData.portText = response.data.portText;
			this.formData.ipaddressText = response.data.ipaddressText;
			this.formData.ipaddressVPNText = response.data.ipaddressVPNText;
			this.formData.macaddress = response.data.macaddress;
			this.formData.isActive = response.data.isActive;
			this.formData.isDisabled = response.data.isDisabled;
			this.formData.isWaitingForAcceptProvisioning = response.data.isWaitingForAcceptProvisioning;
			this.formData.isLost = response.data.isLost;
			this.formData.isProcessingTask = response.data.isProcessingTask;
			this.formData.isDeleted = response.data.isDeleted;
			this.formData.idComponentTypeNavigationIdentifier = response.data.idComponentTypeNavigationIdentifier;
			this.formData.slot1 = response.data.slot1;
			this.formData.slot2 = response.data.slot2;
			this.formData.slot3 = response.data.slot3;
			this.getSystemInfoResponse(response.data);
			this.formData.progressList = response.data.progressList;
			this.prepareProgresText();
		}

		refreshItems(items: any, refreshData: any): any {
			items.isActive = refreshData.isActive,
			items.isDisabled = refreshData.isDisabled,
			items.isWaitingForAcceptProvisioning = refreshData.isWaitingForAcceptProvisioning,
			items.isLost = refreshData.isLost,
			items.isProcessingTask = refreshData.isProcessingTask,
			items.isDeleted = refreshData.isDeleted,
			items.idComponentStateNavigationName = refreshData.idComponentStateNavigationName;
			items.progressList = refreshData.progressList;	
			items.slot1 = refreshData.data.slot1;
			items.slot2 = refreshData.data.slot2;
			items.slot3 = refreshData.data.slot3;		
			this.prepareProgresText();
			return items;
		}

	

		protected getSystemInfoResponse(data: any) {
			this.formData.error = data.error;
			this.formData.ipaddressLocalText = data.ipaddressLocalText;
			this.formData.idVariant = data.idVariant;
			this.formData.idVariantText = data.idVariantText;
			this.formData.idComponent = data.idComponent;
			this.formData.idDisplayOrientation = data.idDisplayOrientation;
			this.formData.idDisplayOrientationText = data.idDisplayOrientationText;
			this.formData.enableDisplayTurnOff = data.enableDisplayTurnOff;
			this.formData.sendPrintScreen = data.sendPrintScreen;
			this.formData.audioEnabled = data.audioEnabled;
			this.formData.idAudioOutput = data.idAudioOutput;
			this.formData.idContentInBootUpScreen = data.idContentInBootUpScreen;
			this.formData.idContentInBootUpScreenText = data.idContentInBootUpScreenText;
			this.formData.backgroundColor = data.backgroundColor;
			this.formData.taskActual = data.taskActual;
			this.formData.taskCommon = data.taskCommon;
			this.formData.taskPriority = data.taskPriority;
			this.formData.taskIdle = data.taskIdle;
			this.formData.idGroupNavigationName = data.idGroupNavigationName;
			this.formData.tags = data.tags;
			this.formData.idAudioOutputText = data.idAudioOutputText;
			this.formData.operatingSystem = data.operatingSystem;
			this.formData.dotnet = data.dotnet;
			this.formData.programVersion = data.programVersion;
			this.formData.displayResolution = data.displayResolution;
			this.formData.storage = data.storage;
			this.formData.storageData = data.storageData;
			this.formData.cPU = data.cpu;
			this.formData.cPUTemperature = data.cpuTemperature;
			this.formData.rAM = data.ram;
			this.formData.hardwarePlatform = data.hardwarePlatform;
			this.formData.videoOutput = data.videoOutput;
			this.formData.audioOutput = data.audioOutput;
			this.formData.contentInBootUpScreen = data.contentInBootUpScreen;
			this.formData.useCPU = data.useCPU;
			this.formData.uptime = tlResponseToUptimeString(data.uptime);
			this.formData.localTime = tlISODateTimeToLocalString(data.localTime);
			this.formData.dateOfConfiguration = tlISODateTimeToLocalString(data.dateOfConfiguration);
		}

		progressText = "";

		prepareProgresText() {
			this.progressText = (this.formData.progressList == null || (this.formData.progressList! as Array<any>).length == 0) ? this.$t('component.taskNotAssigned').toString()/*"není přiřazena úloha ke zpracování"*/ : "";
		}

		doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('component.messageNew').toString(), this.$t('component.messageEdit').toString(), this.$t('component.messageDelete').toString());
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			//@ts-ignore
			delete this.formData.dateOfConfiguration;
			this.formData.idGroupNavigationName = this.stateText('idGroup');
			return this.componentService.update(this.objectId, this.formData);
		}

		private stateText(name: string): string {
			var e = (document.getElementById(name)) as HTMLSelectElement;

			if (e == null)
				return '';
			if (e.selectedOptions[0] == undefined) {
				return '';
			}
			return e.selectedOptions[0].innerText;
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.componentService.delete(this.objectId);
		}

		showAcceptProvisionButton() {
			return (this.styleFormDetail) && this.formData.isWaitingForAcceptProvisioning && RightHelper.currentUserHasRight('COR_Component_Provisioning');
		}

		showActivateButton() {
			return (this.styleFormDetail) && this.formData.isDisabled && this.canUpdate;
		}

		showDeactivateButton() {
			return (this.styleFormDetail) && this.formData.isActive && this.canUpdate;
		}

		showStopProcessingTaskOnComponentButton() {
			return (this.styleFormDetail) && this.formData.isProcessingTask && this.canUpdate && this.formData.isReceiverComponent;
		}

		acceptProvisionComponent() {
			super.callActionAndShowErrorInfoMessage(this.componentService.acceptProvision(this.objectId), this.$t('component.messageAdd').toString());
		}

		activateComponent() {
			super.callActionAndShowErrorInfoMessage(this.componentService.activateComponent(this.objectId), this.$t('component.messageActivate').toString());
		}

		deactivateComponent() {
			super.callActionAndShowErrorInfoMessage(this.componentService.deactivateComponent(this.objectId), this.$t('component.messageDeactivate').toString());
		}

		stopTask() {
			super.callActionAndShowErrorInfoMessage(this.componentService.stopTask(this.objectId), this.$t('component.messageTaskStop').toString());
		}

		stopProcessingTaskOnComponent() {
			super.callActionAndShowErrorInfoMessage(this.componentService.stopProcessingTaskOnComponent(this.objectId), this.$t('component.messageStop').toString());
		}

		vIsCorrectName: boolean = true;
		vIsCorrectComponentId: boolean = true;

		validateBase() {
			return !(this.vIsCorrectName && this.isCorrectComponentIdBase);
		}

		isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		isCorrectComponentIdBase(value: any) {
			this.vIsCorrectComponentId = value;
		}
	}


